import { MintDefault } from './MintDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

MintDefault.Navbar = LogoLayoutNavbar;

export default MintDefault;
